import {
    getProduct,
    listSubscriptionItems
} from './queries';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CreateSubscriptionItem,
    DeleteSubscriptionItem,
    GetSubscriptionItem,
    ListSubscriptionItems,
    SubscriptionItem,
    UpdateSubscriptionItem
} from "../types.ts";
import {
    notifyError,
    notifySuccess
} from "../../../components/PlatformNotification";
import {generateClient} from "aws-amplify/api";
import {
    createSubscriptionItem,
    deleteSubscriptionItem,
    updateSubscriptionItem
} from "./mutations.ts";
import {ListRecordsQuery} from "../../../types";
import {moduleConfig} from "../config";


const client = generateClient();


export const fetchRecords = async (query: ListRecordsQuery) => {

    try {
        const response = await client.graphql<GraphQLQuery<ListSubscriptionItems>>({
                                                                                       query: listSubscriptionItems,
                                                                                       variables: {
                                                                                           ...query
                                                                                       },
                                                                                   });
        return {
            items: response.data?.listSubscriptionItems.items,
            nextToken: response.data?.listSubscriptionItems.nextToken
        };
    } catch (e) {
        console.trace(e);
    }
};

export const fetch = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetSubscriptionItem>>({
                                                                                     query: getProduct,
                                                                                     variables: {id: id},
                                                                                 });
        return response.data?.getSubscriptionItem;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const add = async (payload: object) => {

    try {
        const response = await client.graphql<GraphQLQuery<CreateSubscriptionItem>>({
                                                                                        query: createSubscriptionItem,
                                                                                        variables: {input: payload},
                                                                                    });
        console.debug('in the service response', response);
        notifySuccess(`${moduleConfig.titles.singular} created`);
        return response.data?.createSubscriptionItem;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const update = async (id: string, record: SubscriptionItem) => {

    console.debug('IN UPDATE', id, record);

    delete record.created;
    delete record.updated;

    try {
        const response = await client.graphql<GraphQLQuery<UpdateSubscriptionItem>>({
                                                                                        query: (updateSubscriptionItem),
                                                                                        variables: {input: record},
                                                                                    });
        notifySuccess(`${moduleConfig.titles.singular} updated`)
        return response.data?.updateSubscriptionItem;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const deleteRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteSubscriptionItem>>({
                                                                                        query: (deleteSubscriptionItem),
                                                                                        variables: {input: {id: id}},

                                                                                    });
        notifySuccess(`${moduleConfig.titles.singular} deleted`)
        return response.data?.deleteSubscriptionItem;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};
